import { parrier } from './parrier';
// export for module
export default parrier;
// export for commonjs
module.exports = parrier;
